import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';

import edgeMarketLogo from '#assets/images/EDGE_Boost_Logo_v2-sm.png';

import AppMenu from './components/app-menu/app-menu.view';
import styles from './left-sidebar.module.scss';

export default function LeftSidebar({
    isCondensed = false,
    isMobileOpen = false,
    onCloseMobileMenu,
}) {
    const menuNodeRef = useRef(null);

    useEffect(() => {
        if (!isMobileOpen) return undefined;

        const handleOtherClick = (event) => {
            if (menuNodeRef.current && menuNodeRef.current.contains(event.target)) return;
            // Let the topbar hamburger toggle handle open/close itself.
            if (event.target.closest?.('.button-menu-mobile')) return;
            onCloseMobileMenu?.();
        };

        document.addEventListener('mousedown', handleOtherClick, false);
        return () => {
            document.removeEventListener('mousedown', handleOtherClick, false);
        };
    }, [isMobileOpen, onCloseMobileMenu]);

    return (
        <div
            ref={menuNodeRef}
            className={classNames('left-side-menu', styles.sidebar, {
                'sidebar-enable': isMobileOpen,
            })}
        >
            <div className={styles.logo}>
                <img src={edgeMarketLogo} alt="EdgeBoost" className="img-fluid p-3" />
            </div>
            <div className={styles.menuScroll}>
                <AppMenu onNavigate={onCloseMobileMenu} />
            </div>
        </div>
    );
}
